import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  computed,
  effect,
  input,
} from '@angular/core';
import { BrnAccordionContent } from '@spartan-ng/brain/accordion';
import { hlm } from '@spartan-ng/helm/utils';

import type { ClassValue } from 'clsx';

@Component({
  selector: 'hlm-accordion-content',
  template: `
    <div [attr.inert]="_inert()" style="overflow: hidden">
      <p [class]="userClass()">
        <ng-content />
      </p>
    </div>
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class]': '_computedClass()',
    '[attr.data-state]': 'state()',
    '[attr.aria-labelledby]': 'ariaLabeledBy',
    '[attr.id]': 'id',
    role: 'region',
  },
})
export class HlmAccordionContentComponent extends BrnAccordionContent {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  public readonly userClass = input<ClassValue>('', { alias: 'class' });
  protected readonly _computedClass = computed(() => {
    const gridRows = this.state() === 'open' ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]';
    return hlm('text-sm transition-all grid', gridRows, this.userClass());
  });

  constructor() {
    super();
    effect(() => {}, { allowSignalWrites: true });
  }
}
